import api from '../../../../api';

export const RadioSelector = {
  INPUT: api.internals.ns.selector('radio-group [type="radio"]')
};
